export default __webpack_public_path__ + "static/media/email.952575ac.svg";